import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getsCartData,
  getsCompareData,
  getsWishData,
} from "../actions/wishCompareCart";
import { withTranslation } from "react-i18next";
import favIcon from "../images/fav_icon.svg";
import compareIcon from "../images/compare_icon.svg";
import cartIcon from "../images/cart_icon.svg";

import { Link } from "react-router-dom";
import i18n from "i18next";
import UserBar from "./userBar";

class WishCartCompareBar extends Component {
  static propTypes = {
    wishData: PropTypes.object,
    cartData: PropTypes.object,
    compareData: PropTypes.object,
  };

  componentDidMount() {
    this.props.getsCartInfo();
    this.props.getsWishInfo();
    this.props.getsCompareInfo();
  }

  render() {
    const { t } = this.props;
    return (
      <>
       
       
        <div className=" ">
          <Link className="header__fav-link uk-position-relative" to={"/products/" + i18n.language + "/wishlist/list/"} title={t('shop.favorite')}>
            <img alt={""} className="header__fav-btn" src={favIcon} uk-svg=""  />
            <span className="header__fav-count">
            {Object.keys(this.props.wishData).length > 0
              ? this.props.wishData.countItem
              : ""}
            </span>
            
          </Link>
        </div>
        <div className="uk-margin-left  ">
          <Link className="header__compare-link uk-position-relative"  to={"/products/" + i18n.language + "/compare/list/"} title={t('shop.compare')}>
            <img alt={""} className="header__compare-btn" src={compareIcon} uk-svg="" />
            <span className="header__compare-count">
            {Object.keys(this.props.cartData).length > 0
              ? this.props.compareData.countItem
              : ""}
              </span>
          </Link>
        </div>
        <div className="uk-margin-left  ">
          <Link
            className="header__cart-link uk-position-relative"
            to={"/products/" + i18n.language + "/cart/list/"}
            title={t('cart.cartname')}
          >
            <img
              alt={""}
              className="header__cart-btn"
              src={cartIcon}
              uk-svg=""
            />
            <span className="header__cart-count">
              {
                
              }
              {Object.keys(this.props.cartData).length > 0
                ? 
                // this.props.cartData.countItem,
                Object.keys(this.props.cartData.data).length  //sorry hardcode
                : ""}
            </span>
          </Link>
        </div>
        <div className=" uk-margin-left uk-visible@m">
      
            <UserBar />
          
        </div>
      </> 
    );
  }
}

const mapStateToProps = (store) => {
  const { wishData, cartData, compareData, isShowCompareCartWishLoader } =
    store.wishCompareCart;
  return {
    wishData,
    cartData,
    compareData,
    isShowCompareCartWishLoader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getsCartInfo: () => {
      dispatch(getsCartData());
    },
    getsWishInfo: () => {
      dispatch(getsWishData());
    },
    getsCompareInfo: () => {
      dispatch(getsCompareData());
    },
  };
};

const WishBar = withTranslation("translations")(WishCartCompareBar);

export default connect(mapStateToProps, mapDispatchToProps)(WishBar);
